<script>
import { Navigation, Pagination, FreeMode, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import Media from '@/components/elements/Media.vue';

export default {
    name: 'Carousel',
    setup () {
        return {
            modules: [Navigation, Pagination, FreeMode, A11y]
        };
    },
    components: {
        Swiper,
        SwiperSlide,
        Media
    }
};
</script>